module.exports = __webpack_public_path__ + "assets/images/team/5.jpg";